export default __webpack_public_path__ + "static/media/04.44439fab.jpg";